const nav = typeof navigator !== 'undefined' ? navigator : null;
const agent = (nav && nav.userAgent) || '';

// Is true for both iOS and iPadOS for convenience
export const android = /Android \d/.test(agent);
